import React, { useMemo } from 'react';

const MomentumChart = ({ pointLog, nameA, nameB, colorA = '#818cf8', colorB = '#fb7185' }) => {
  const data = useMemo(() => {
    if (!pointLog || pointLog.length === 0) return [];
    let runA = 0, runB = 0, momentum = 0;
    return pointLog.map((p, i) => {
      if (p.scorer === 'A') { runA++; runB = 0; momentum = Math.min(momentum + 1, 8); }
      else { runB++; runA = 0; momentum = Math.max(momentum - 1, -8); }
      return { i, momentum, scorer: p.scorer, scoreA: p.scoreA, scoreB: p.scoreB };
    });
  }, [pointLog]);

  if (data.length === 0) return (
    <div className="flex items-center justify-center h-24 text-white/20 text-sm font-bold">無數據</div>
  );

  const W = 320, H = 80, mid = H / 2;
  const xStep = data.length > 1 ? (W - 20) / (data.length - 1) : W;
  const yScale = mid / 8;

  const pathA = data
    .filter(d => d.momentum > 0)
    .map((d, _, arr) => `${10 + d.i * xStep},${mid - d.momentum * yScale}`)
    .join(' ');

  const linePoints = data.map(d => `${10 + d.i * xStep},${mid - d.momentum * yScale}`).join(' ');

  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-4">
      <div className="flex items-center justify-between mb-3">
        <p className="text-[10px] font-black text-white/40 uppercase tracking-widest">比賽動量</p>
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1.5">
            <div className="w-2 h-2 rounded-full" style={{ backgroundColor: colorA }} />
            <span className="text-[10px] font-bold text-white/50">{nameA}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <div className="w-2 h-2 rounded-full" style={{ backgroundColor: colorB }} />
            <span className="text-[10px] font-bold text-white/50">{nameB}</span>
          </div>
        </div>
      </div>
      <svg viewBox={`0 0 ${W} ${H}`} className="w-full" style={{ height: 80 }}>
        {/* Zero line */}
        <line x1="0" y1={mid} x2={W} y2={mid} stroke="rgba(255,255,255,0.1)" strokeWidth="1" strokeDasharray="4,3" />
        {/* Area fills */}
        <defs>
          <clipPath id="clip-above"><rect x="0" y="0" width={W} height={mid} /></clipPath>
          <clipPath id="clip-below"><rect x="0" y={mid} width={W} height={mid} /></clipPath>
        </defs>
        {data.length > 1 && (
          <>
            <polyline points={linePoints} fill="none" stroke={colorA} strokeWidth="1.5"
              opacity="0.7" strokeLinejoin="round" clipPath="url(#clip-above)" />
            <polyline points={linePoints} fill="none" stroke={colorB} strokeWidth="1.5"
              opacity="0.7" strokeLinejoin="round" clipPath="url(#clip-below)" />
          </>
        )}
        {/* Dots for key moments */}
        {data.filter((_, i) => i % Math.max(1, Math.floor(data.length / 10)) === 0).map(d => (
          <circle key={d.i} cx={10 + d.i * xStep} cy={mid - d.momentum * yScale} r="2.5"
            fill={d.scorer === 'A' ? colorA : colorB} opacity="0.9" />
        ))}
      </svg>
      <div className="flex justify-between mt-1">
        <span className="text-[9px] text-white/25 font-bold">開始</span>
        <span className="text-[9px] text-white/25 font-bold">結束</span>
      </div>
    </div>
  );
};

export default MomentumChart;